module.exports = __webpack_public_path__ + "img/Editor.3586032f.gif";